/** Angular Imports */
import { Component, OnInit, inject } from "@angular/core";

/** Custom Service */
import { SettingsService } from "./settings.service";
import { UntypedFormControl, ReactiveFormsModule } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from "@angular/material/expansion";
import { FileUploadComponent } from "../shared/file-upload/file-upload.component";
import { ThemePickerComponent } from "../shared/theme-picker/theme-picker.component";
import { STANDALONE_SHARED_IMPORTS } from "app/standalone-shared.module";

/**
 * Settings component.
 */
@Component({
  selector: "LOSx-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  imports: [
    ...STANDALONE_SHARED_IMPORTS,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    FileUploadComponent,
    ThemePickerComponent,
  ],
})
export class SettingsComponent implements OnInit {
  private settingsService = inject(SettingsService);
  private translateService = inject(TranslateService);

  /** Supported languages. */
  languages: any[] = [];
  /** Date formats. */
  dateFormats: string[] = [
    "dd MMMM yyyy",
    "dd/MMMM/yyyy",
    "dd-MMMM-yyyy",
    "dd-MM-yy",
    "MMMM-dd-yyyy",
    "MMMM dd yyyy",
    "MMMM/dd/yyyy",
    "MM-dd-yy",
    "yyyy-MM-dd",
  ];
  /** Decimals. */
  decimals: string[] = ["0", "1", "2", "3", "4", "5", "6", "7", "8"];
  /** Placeholder for fonts. */
  fonts: any;

  /** Language Setting */
  language = new UntypedFormControl("");
  /** Date Format Setting */
  dateFormat = new UntypedFormControl("");
  /** Decimals to Display Setting */
  decimalsToDisplay = new UntypedFormControl("");

  ngOnInit() {
    this.languages = this.translateService.getLangs().map((code) => ({
      name: this.translateService.instant(`languages.${code}`),
      code: code.substring(0, 2),
    }));
    this.language.patchValue(this.settingsService.language);
    this.dateFormat.patchValue(this.settingsService.dateFormat);
    this.decimalsToDisplay.patchValue(this.settingsService.decimals);
    this.buildDependencies();
  }

  /**
   * Subscribe to value changes.
   */
  buildDependencies() {
    this.language.valueChanges.subscribe((language: any) => {
      this.settingsService.setLanguage(language);
    });
    this.dateFormat.valueChanges.subscribe((dateFormat: string) => {
      this.settingsService.setDateFormat(dateFormat);
    });
    this.decimalsToDisplay.valueChanges.subscribe((decimals: string) => {
      this.settingsService.setDecimalToDisplay(decimals);
    });
  }

  /**
   * Compare function for mat-select.
   * Useful in patching values if value is an object.
   * @param {any} option1 option 1
   * @param {any} option2 option 2.
   */
  compareOptions(option1: any, option2: any) {
    return option1 && option2 && option1.code === option2.code;
  }
}
